import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import { Card, Grid, Typography } from "@mui/material";
import useWindowDimensions from "../hooks/getScreenDimensions";
import Punjab from "../../public/land/provinces/Punjab.jpeg";
import "yet-another-react-lightbox/styles.css";
const provincesCard = [
  {
    id: 1,
    image: Punjab,
    name: "Punjab",
  }
];
export default function Provinces({setProvince}) {
  const handlePopUpOpen = (card) => {
    setProvince(
      {
        id : card.id,
        name : card.name
      }
    )
  };
  const { width } = useWindowDimensions();

  const options = {
    margin: 10,
    responsive: {
      0: { items: 1, dots: false },
      500: { items: 2, dots: false },
      900: { items: 3, dots: false },
      1050: { items: 4 },
      2500: { items: 5 },
    },
  };
  return (
    <>
      <Grid container justifyContent="center" alignItems="center" mt={3}>
        <Grid item xs={12}></Grid>
        <Grid item xs={10}>
          <OwlCarousel className="owl-theme" {...options}>
            {provincesCard.map((card, index) => (
              <div
                key={card.id}
                className="item"
                style={{ cursor: "pointer" }}
                onClick={() => handlePopUpOpen(card)}
              >
                <Card
                  style={{
                    marginBottom: "10px",
                    height:
                      width < 800
                        ? "350px"
                        : width < 1800
                        ? "300px"
                        : width < 2500
                        ? "350px"
                        : "550px",
                  }}
                >
                  <img
                    src={card.image}
                    alt={`img_${card.id}`}
                    style={{
                      width: "100%",
                      height:
                        width < 800
                          ? "350px"
                          : width < 1800
                          ? "300px"
                          : width < 2500
                          ? "350px"
                          : "550px",
                    }}
                  />
                </Card>
                <Typography variant="h9" fontFamily="Poppins">
                  <strong>{card.name}</strong>
                </Typography>
              </div>
            ))}
          </OwlCarousel>
        </Grid>
      </Grid>
    </>
  );
}
